import { CalendarOff, Zap, BrainCircuit, Eye } from "lucide-react";

const features = [
  {
    icon: CalendarOff,
    title: "No Fixed Calendar Dates",
    description:
      "Zero pre-printed dates mean zero visual penalties for taking a break to recover from burnout.",
  },
  {
    icon: Zap,
    title: "Energy-Based Focus Blocks",
    description:
      "Stop staring at an endless to-do list. Filter your tasks by how much physical and mental energy you have right now: High, Low, or Negative.",
  },
  {
    icon: BrainCircuit,
    title: "The Brain Dump Space",
    description:
      "Clear out the mental clutter first. Get the chaotic thoughts out of your head so you can focus on the single task in front of you.",
  },
  {
    icon: Eye,
    title: "High-Contrast, Low-Stimulation Design",
    description:
      "Clean, simple layouts that do not trigger sensory overwhelm. No habit charts, no complicated daily metrics.",
  },
];

export default function FeaturesSection() {
  return (
    <section
      data-testid="features-section"
      className="py-20 md:py-28"
      style={{ backgroundColor: "#1e1e1f" }}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        {/* Heading */}
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight mb-4 text-center"
          style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
          data-testid="features-heading"
        >
          The first planning system designed to be paused.
        </h2>

        {/* Intro */}
        <p
          className="text-base leading-relaxed mb-14 text-center max-w-2xl mx-auto"
          style={{ fontFamily: "'Inter', sans-serif", color: "#b0b0b5" }}
        >
          This tracker is completely undated and modular. It does not care if you
          skip a day, a week, or a month. When you are ready to plan, you simply
          print a sheet or open your app and start fresh on a blank slate.
        </p>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <div
                key={i}
                className="rounded-2xl p-8 transition-colors duration-300"
                style={{
                  backgroundColor: "rgba(255,255,255,0.02)",
                  border: "1px solid rgba(255,255,255,0.08)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.04)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.02)";
                }}
                data-testid={`feature-card-${i}`}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                  style={{ backgroundColor: "rgba(124, 58, 237, 0.12)" }}
                >
                  <Icon className="w-6 h-6" style={{ color: "#7C3AED" }} />
                </div>
                <h3
                  className="text-lg font-medium mb-3"
                  style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
                >
                  {feature.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif", color: "#b0b0b5" }}
                >
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
